import { render, staticRenderFns } from "./SubjectAreasIndex.vue?vue&type=template&id=8edc1f64&"
import script from "./SubjectAreasIndex.vue?vue&type=script&lang=ts&"
export * from "./SubjectAreasIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports